<template>
  <CCard>
    <CCardHeader>
      <CIcon name="cil-https" /> Puntos obtenidos
      <div class="text-muted" style="font-size:12px;">
        Administración de puntos por tipo de usuario
      </div>
    </CCardHeader>

    <CCardBody>
      <!-- Tabs header -->
      <CTabs>
        <CTab title="Vendedores" :active="activeTab === 'suppliers'" @click.native="activeTab = 'suppliers'" />
        <CTab title="Supervisores" :active="activeTab === 'managers'" @click.native="activeTab = 'managers'" />
        <CTab title="Gerentes" :active="activeTab === 'gerentes'" @click.native="activeTab = 'gerentes'" />
      </CTabs>

      <!-- Content -->
      <div v-show="activeTab === 'suppliers'">
        <PointsTable entityType="suppliers" :items="suppliers" hover striped border small fixed caption="Puntos Canjeables – Vendedores"
          @refreshSuppliers="refreshSuppliers" :permissions="permissions" />
      </div>

      <div v-show="activeTab === 'managers'">
        <PointsTable entityType="managers" :items="managers" hover striped border small fixed caption="Puntos Canjeables – Supervisores"
          @refreshManagers="refreshManagers" :permissions="permissions" />
      </div>

      <div v-show="activeTab === 'gerentes'">
        <PointsTable entityType="gerentes" :items="gerentes" hover striped border small fixed caption="Puntos Canjeables – Gerentes"
          @refreshGerentes="refreshGerentes" :permissions="permissions" />
      </div>
    </CCardBody>
  </CCard>
</template>

<script>
import PointsTable from '../../components/reports/PointsTable.vue'
import ws_suppliers from '../../services/suppliers'
import ws_managers from '../../services/managers'
import ws_executives from '../../services/executives'
import account_ws from '../../services/account';
import store from '../../store'

export default {
  name: 'ReportPoints',
  components: { PointsTable },
  data: function () {
    return {
      activeTab: 'suppliers',
      suppliers: [],
      managers: [],
      gerentes: [],
      permissions: null
    }
  },
  mounted: async function () {
    this.loading();
    // Puntos vendedores
    await this.refreshSuppliers();

    // Puntos supervisores 
    await this.refreshManagers();

    // Puntos gerentes
    await this.refreshGerentes();

    let response = await account_ws.getInfo();

    if (response.type == "success") {
      this.permissions = response.data.user.permissions;
    }

    this.loaded();
  },
  methods: {
    async refreshSuppliers() {
      this.loading();
      let resSuppliers = await ws_suppliers.getRedeemablePoints();
      if (resSuppliers.type == "success") {
        this.suppliers = resSuppliers.data;
      }
      this.loaded();
    },
    async refreshManagers() {
      let resManagers = await ws_managers.getRedeemablePoints();
      if (resManagers && resManagers.type === 'success') {
        this.managers = resManagers.data;
      }

    },
    async refreshGerentes() {
      let resGerentes = await ws_executives.getRedeemablePoints();
      if (resGerentes && resGerentes.type === 'success') {
        this.gerentes = resGerentes.data;
      }
    },
    loading() {
      store.commit('loading');
    },
    loaded() {
      store.commit('loaded');
    }
  }
}
</script>
<style>
/* ===== CoreUI Tabs estilo "Información / Dinámica" ===== */

/* contenedor */
.nav-tabs {
  border-bottom: 1px solid #d8dbe0;
}

/* tab base */
.nav-tabs .nav-link {
  border: 1px solid transparent;
  border-bottom: none;
  background-color: transparent;
  color: #6c757d;
  padding: 8px 16px;
  /* +2px vertical y horizontal */
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}

/* hover SOLO cuando NO está activa */
.nav-tabs .nav-link:not(.active):hover {
  color: #495057;
  background-color: transparent;
}

/* tab activa */
.nav-tabs .nav-link.active {
  color: #495057;
  background-color: #f0f3f5;
  border-color: #d8dbe0 #d8dbe0 #f0f3f5;
  font-weight: 500;
}

/* quitar cualquier efecto azul */
.nav-tabs .nav-link:focus {
  outline: none;
  box-shadow: none;
}

/* asegurar que no haya underline */
.nav-tabs .nav-link::after {
  display: none !important;
}
</style>
